module.exports = __webpack_public_path__ + "media/images/home/EatOkraxUberEats1_tiny-17e4d36e170adc796f7cfb01e85823e8.png";